<template>
  <router-link :to="to" style="text-decoration: none" v-if="hasPermission">
    <slot></slot>
  </router-link>
  <span v-else>
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'AppRouterLink',
  props: {
    to: Object,
    permission: Object,
  },
  computed: {
    hasPermission() {
      if (!this.permission) {
        return true;
      }
      return this.$ability.can(this.permission.action, this.permission.subject);
    },
  },
};
</script>

<style>
</style>
